import { Injectable } from '@angular/core';
import { GetMagiiAccessPortal, IGetMagiiAccessPortalParameters, IGetMagiiAccessPortalResponse } from './command/getMagiiAccessPortal.command';
import { catchError, map, Observable, throwError } from 'rxjs';
import { AddMagiisAccessCarrierProfile, IAddMagiisAccessCarrierProfileParameters } from './command/addMagiisAccessCarrierProfile.command';
import { IUpdateMagiisAccessCarrierProfileParameters, UpdateMagiisAccessCarrierProfile } from './command/updateMagiisAccessCarrierProfile.command';
import { GetAllMagiisAccessCarrierProfile, IGetAllMagiisAccessCarrierProfileParameters, IGetAllMagiisAccessCarrierProfileResponse } from './command/getAllMagiisAccessCarrierProfile.command';
import { DeleteMagiisAccessCarrierProfile, IDeleteMagiisAccessCarrierProfileRequest } from './command/deleteMagiisAccessCarrierProfile.command';
import { IUpdateMagiisAccessCarrierProfileAccessParameters, UpdateMagiisAccessCarrierProfileAccess } from './command/updateMagiisAccessCarrierProfileAccess.command';
import { CreateMagiisAccessUserProfileMagiisUserId, ICreateMagiisAccessUserProfileMagiisUserIdParameters } from './command/createMagiisAccessUserProfileMagiisUserId.command';
import { CreateMagiisAccessUserProfileCarrierProfileId, ICreateMagiisAccessUserProfileCarrierProfileIdParameters } from './command/createMagiisAccessUserProfileCarrierProfileId.command';
import { GetMagiisAccessCarrierProfile, IGetMagiisAccessCarrierProfileParameters, IGetMagiisAccessCarrierProfileResponse } from './command/getMagiisAccessCarrierProfile.command';
import { ConnectionServices } from '../authentication/connection/connection.service';

@Injectable()
export class ProfileAccessService {

  constructor(
    private _connectionService: ConnectionServices,
  ) { }

  public getAllCarrierProfile(
    request: IGetAllMagiisAccessCarrierProfileParameters
  ): Observable<IGetAllMagiisAccessCarrierProfileResponse> {
    const driverCommand = new GetAllMagiisAccessCarrierProfile();
    driverCommand.setParameters(request);
    return this._connectionService
      .Request(driverCommand)
      .pipe(
        map(data => {
          const response = data as IGetAllMagiisAccessCarrierProfileResponse;
          return response;
        }),
        catchError(error => {
          return throwError(error);
        })
      )
  }

  public getCarrierProfile(
    request: IGetMagiisAccessCarrierProfileParameters
  ): Observable<IGetMagiisAccessCarrierProfileResponse> {
    const driverCommand = new GetMagiisAccessCarrierProfile();
    driverCommand.setParameters(request);
    return this._connectionService
      .Request(driverCommand)
      .pipe(
        map(data => {
          const response = data as IGetMagiisAccessCarrierProfileResponse;
          return response;
        }),
        catchError(error => {
          return throwError(error);
        })
      )
  }

  public getPortal(
    portal:number,
    type?: string,
  ): Observable<IGetMagiiAccessPortalResponse> {
    const driverCommand = new GetMagiiAccessPortal();
    driverCommand.setParameters(<IGetMagiiAccessPortalParameters>{
      portal,
      type,
    });
    return this._connectionService
      .Request(driverCommand)
      .pipe(
        map(data => {
          const response = data as IGetMagiiAccessPortalResponse;
          return response;
        }),
        catchError(error => {
          return throwError(error);
        })
      )
  }

  public createCarrierProfile(
    request: IAddMagiisAccessCarrierProfileParameters
  ): Observable<Boolean> {
    const driverCommand = new AddMagiisAccessCarrierProfile();
    driverCommand.setParameters(request);
    return this._connectionService
      .Request(driverCommand)
      .pipe(
        map(() => {
          return true;
        }),
        catchError(error => {
          return throwError(error);
        })
      )
  }

  public updateCarrierProfile(
    request: IUpdateMagiisAccessCarrierProfileParameters
  ): Observable<Boolean> {
    const driverCommand = new UpdateMagiisAccessCarrierProfile();
    driverCommand.setParameters(request);
    return this._connectionService
      .Request(driverCommand)
      .pipe(
        map(() => {
          return true;
        }),
        catchError(error => {
          return throwError(error);
        })
      )
  }

  public deleteCarrierProfile(
    request: IDeleteMagiisAccessCarrierProfileRequest
  ): Observable<Boolean> {
    const driverCommand = new DeleteMagiisAccessCarrierProfile();
    driverCommand.setParameters(request);
    return this._connectionService
      .Request(driverCommand)
      .pipe(
        map(() => {
          return true;
        }),
        catchError(error => {
          return throwError(error);
        })
      )
  }

  public updateCarrierProfileAccess(
    request: IUpdateMagiisAccessCarrierProfileAccessParameters
  ): Observable<Boolean> {
    const driverCommand = new UpdateMagiisAccessCarrierProfileAccess();
    driverCommand.setParameters(request);
    return this._connectionService
      .Request(driverCommand)
      .pipe(
        map(() => {
          return true;
        }),
        catchError(error => {
          return throwError(error);
        })
      )
  }

  public createUserProfileMagiisUserId(
    request: ICreateMagiisAccessUserProfileMagiisUserIdParameters
  ): Observable<Boolean> {
    const driverCommand = new CreateMagiisAccessUserProfileMagiisUserId();
    driverCommand.setParameters(request);
    return this._connectionService
      .Request(driverCommand)
      .pipe(
        map(() => {
          return true;
        }),
        catchError(error => {
          return throwError(error);
        })
      )
  }

  public createUserProfileCarrierProfileId(
    request: ICreateMagiisAccessUserProfileCarrierProfileIdParameters
  ): Observable<Boolean> {
    const driverCommand = new CreateMagiisAccessUserProfileCarrierProfileId();
    driverCommand.setParameters(request);
    return this._connectionService
      .Request(driverCommand)
      .pipe(
        map(() => {
          return true;
        }),
        catchError(error => {
          return throwError(error);
        })
      )
  }
}
